import { useProductContractHandoff } from "@/api/services/admin/product-contract";
import { LoadingScreen } from "@/components/elements/Loading/Loading";
import { TopPage } from "@/components/elements/TopPage";
import { CompanyForm } from "@/features/company/components/CompanyForm";
import { AppRoutes } from "@/routes/config";
import { Stack } from "@mui/material";
import { FC } from "react";
import { Navigate } from "react-router-dom";

type TCompanyCreatePageProps = {};

export const CompanyCreatePage: FC<TCompanyCreatePageProps> = () => {
  const { canCreateCompany, isLoading } = useProductContractHandoff();

  if (isLoading) return <LoadingScreen />;
  if (!canCreateCompany) return <Navigate to={AppRoutes.pageNotFound} replace />;

  return (
    <Stack gap={4}>
      <TopPage title="受け入れ企業を追加" description="企業の基本情報を入力して追加しましょう" enablePageBack={false} />
      <CompanyForm />
    </Stack>
  );
};
